module.exports = __webpack_public_path__ + "static/index_hero-f6fa2981f57a4b024adf06cd8c106153.svg";